var BufferFormatter = require('bufferformatter');


var BufferNickView = Backbone.View.extend({
    tagName: 'span',
    className: 'buffernick',
    initialize: function (options) {
        this.buffer = options.buffer || this.model;

        this.listenTo(this.buffer.getUser(), 'change:nick', this.render);
        this.listenTo(this.buffer.getUser(), 'change:display_name', this.render);
        this.listenTo(this.buffer.getUser(), 'change:away', this.render);
        this.listenTo(this.buffer.getUser(), 'change:avatar', this.render);
        this.listenTo(this.buffer.getUser(), 'change:mode', this.render);
        this.listenTo(this.buffer.getUser(), 'change:avatar_url', this.render);
        this.listenTo(this.buffer.getUser(), 'change:avatars_supported', this.render);
        this.listenTo(this.buffer.getUser(), 'change:ircserver', this.render);
        this.listenTo(this.buffer.getUser(), 'change:hostname', this.render);
        this.listenTo(this.buffer.getUser(), 'change:usermask', this.render);
        this.listenTo(this.buffer.getUser(), 'change:account', this.render);

        this.listenTo(this.model.session, 'change:avatar', this.render);
        this.listenTo(this.model.session, 'change:avatar_url', this.render);

        this.buffer.bind('change:avatar', this.render, this);
        this.buffer.bind('change:avatar_url', this.render, this);
        this.buffer.bind('prefChange:inlineimages', this.render, this);
        this.buffer.bind('prefChange:avatars-off', this.render, this);
        this.buffer.bind('prefChange:avatars-image-off', this.render, this);
        this.buffer.bind('activeChange', this.render, this);
        this.buffer.bind('remove', this.remove, this);
        this.formatter = new BufferFormatter(this.buffer);
    },
    events: {
        'click .nick': 'click',
        'click .avatar': 'clickAvatar',
        'click .avatar-upload-prompt__dismiss': 'clickAvatarPromptDismiss',
        'click .avatar-upload-prompt': 'clickAvatar'
    },
    click: function (e) {
        this.model.connection.trigger('nickPrompt');
        return false;
    },
    clickAvatarPromptDismiss: function (e) {
        this.model.connection.setPromptAvatarPref(false);
        return false;
    },
    clickAvatar: function (e) {
        if (!this.model.connection.avatarUploadsSupported()) {
            return;
        }
        var props = {};
        var org = this.model.connection.getOrg();
        var model = this.model.connection;
        if (!this.model.connection.nativeAvatarUploadsSupported()) {
            props.is_primary = true;
            model = this.model.session;
        } else if (org) {
            props.org = org.id;
        } else {
            props.cid = this.model.connection.id;
        }
        this.model.session.trigger('avatarPrompt', model, {
            properties: props
        });
        return false;
    },
    render: function () {
        var user = this.buffer.getUser();
        var userHtml = '';
        var fallback = false;
        var delayFallback = false;
        var external = false;
        var avatar;
        if (this.buffer.imageAvatarsEnabled()) {
            avatar = user.getAvatar({
                buffer: this.buffer
            });
        }
        if (avatar) {
            if (avatar.guess) {
                var sessionAvatar = this.model.session.getUser().getAvatar({strict: true});
                if (sessionAvatar) {
                    avatar = sessionAvatar;
                }
            }
            fallback = true;
            if (!avatar.guess) {
                delayFallback = true;
            }
            external = avatar.external;
            userHtml += this.formatter.imageAvatar(avatar.src, true, {
                size: 24,
                external: external
            });
        }
        var letterOpts = {
            fallback: fallback,
            name: user.getDisplayAuthor(),
            delayFallback: delayFallback,
            external: external
        };
        if (this.model.connection.avatarUploadsSupported()) {
            letterOpts.title = 'Choose an avatar';
            userHtml += this.formatter.avatar(user.get('nick'), true, letterOpts);
            userHtml += '<button class="action avatar-upload-prompt"><span>';
            userHtml += 'Choose an avatar';
            userHtml += '<i class="fa fa-close avatar-upload-prompt__dismiss"></i>';
            userHtml += '</span></button>';
        } else {
            userHtml += this.formatter.avatar(user.get('nick'), true, letterOpts);
        }

        userHtml += this.formatter.linkUserMode(user, {
            className: 'nick'
        });
        $(this.el).html(userHtml);
        return this;
    }
});


module.exports = BufferNickView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/buffernickview.js
// module id = 9PKk
// module chunks = 1